<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-company-contact-list" class="ag-grid-container">

    <div class="vx-card">
      <!-- AgGrid Table -->
      <grid-panel
          ref="distributionListGrid"
          auto-size
          :column-defs="columnDefs"
          :gridOptions="gridOptions"
          :data="data"
          @gridReady="onGridReady"
          @rowClicked="onRowClicked"
          show-deleted-toggle
          @update:deleted="list"
          @update:gridApi="(gridApi) => this.gridApi = gridApi"
      >
        <template v-slot:right>
          <yes-no-toggle v-model="onlyUsers" class="flex mr-4">
            <span class="mr-2">Only Users</span>
          </yes-no-toggle>
        </template>
      </grid-panel>

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import router from "../../../../router";
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import CellRendererRelation from "../../../components/ag-grid/cell-renderer/CellRendererRelation";
import CellRendererVerified from "../../../components/ag-grid/cell-renderer/CellRendererVerified";
import YesNoToggle from "@/views/components/extra-components/YesNoToggle";
import GridPanel from '@/views/components/ag-grid/GridPanel';

export default {
  components: {
    GridPanel,
    AgGridVue,
    vSelect,
    YesNoToggle,
    // Cell Renderer
    CellRendererRelation,
    CellRendererVerified,
  },
  mixins: [CanAccessMixin],
  data () {
    return {

      searchQuery: '',
      showDeleted: false,
      onlyUsers: 0,

      // AgGrid
      gridApi: null,
      gridOptions: {},
      columnDefs: [
        {
          headerName: 'Name',
          field: 'Name',
          filter: 'agTextColumnFilter',
          width: 200,
        },
        {
          headerName: 'Username',
          field: 'EmailAddress',
          filter: 'agTextColumnFilter',
          width: 225
        },
        {
          headerName: 'Role',
          field: 'role',
          filter: 'agTextColumnFilter',
          width: 225,
          cellRenderer: 'CellRendererRelation',
          cellRendererParams(params) {
            return {
              relation: 'roles',
              valueField: 'RoleName',
            }
          },
        },
        {
          headerName: 'Is User',
          field: 'ExternalIdentity_Key',
          width: 125,
          cellRenderer: 'CellRendererVerified',
          cellClass: 'text-center'
        },
        {
          headerName: 'Is Active',
          field: 'IsEnabled',
          filter: true,
          width: 125,
          cellRenderer: 'CellRendererVerified',
          cellClass: 'text-center'
        },
        {
          headerName: 'Main',
          field: 'Main',
          filter: true,
          width: 200,
          cellRenderer: 'CellRendererVerified',
          cellClass: 'text-center',
        },
      ],
      // Cell Renderer Components
      components: {
        CellRendererRelation,
        CellRendererVerified,
      },

      data: [],
    }
  },
  watch: {
    onlyUsers(value) {
      this.list();
    },
    showDeleted(value) {
      this.list({IsDeleted: value | 0});
    }
  },
  computed: {
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },

  mounted () {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    this.list();
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.statusFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    async onRowClicked(row) {
      const { data } = row;
      const route = 'contact.view';

      if (await this.canAccessRoute(route, false)) {
        router.push({name: route, params: {id: data.id}}).catch(() => {});
      }
    },
    async list(isDeleted = 0) {
      const params = {
        'with' : ['roles'],
        'IsDeleted': isDeleted,
      };

      try {
          const relationship = (this.onlyUsers) ? 'users' : 'contacts';
          const { data } = await this.$api.companies.relationship(relationship, this.$route.params.id, params);
          this.data = data.data;
      } catch (e) {
        console.log(e);
      }
    },
  },
}

</script>

<style lang="scss">
#page-company-list {
  .company-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
